import React from 'react';
import styled from 'styled-components';
import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';

const HairMap = styled.div<{
  color?: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
  pointer-events: none;

  img {
    min-width: 100px;
  }
`;

export interface Props {
  data: ISimejiItem;
  color?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function Hair({ data, color }: Props) {
  const { frontHair, sideHair } = data;

  return (
    <HairMap className="body hair" color={color}>
      {/* 정면 */}
      {frontHair && <img className="hair-front" src={frontHair} alt="" />}

      {/* 측면 */}
      {sideHair && <img className="hair-side" src={sideHair} alt="" />}
    </HairMap>
  );
}

export default Hair;
